import { Injectable } from '@angular/core';
import { getValueProperty, setValueProperty } from '../../helpers/functions.helpers';
import { LinkupService } from '../link-up/linkup.service';
import { TokenService } from './token.service';
declare const CV_JS: any;
declare const X: any;

@Injectable({
  providedIn: 'root'
})
export class CryptoVaultService {

  constructor(
    private readonly _token: TokenService,
    private readonly _link: LinkupService
  ) { }

  async keyExchange(transactionId: string) {
    this.clear();
    const { accessToken } = await this._token.accessToken;
    const parameters = await this._link.applicationParameters;
    const contextUrls = await this._link.contextUrls;
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    };
    CV_JS.keyExchange(
      transactionId,
      getValueProperty(parameters, 'data.parameters.criptovault.time_expiration'),
      getValueProperty(parameters, 'data.parameters.criptovault.time_grace'),
      getValueProperty(contextUrls, "URLS.CRYPTO_KEY_SERVER"),
      getValueProperty(contextUrls, "URLS.CRYPTO_KEY_CLIENT"),
      headers,
      {},
    );
    await this.refreshKey();
  }

  encrypt(message: any) {
    return new Promise<any>((resolve, reject) => {
      CV_JS.encrypt(message)
        .then((data: any) => {
          resolve(data);
        })
        .catch((error: any) => {
          this.clear();
          reject(error);
        });
    });
  }

  decrypt(message: any) {
    return CV_JS.decrypt(message);
  }

  async refreshKey() {
    await CV_JS.refreshKey();
  }

  clear() {
    if (X !== void 0) {
      setValueProperty(window, 'X', void 0);
    }
  }
}
